import { render, staticRenderFns } from "./DatosSociedad.vue?vue&type=template&id=0f37869a"
import script from "./DatosSociedad.vue?vue&type=script&lang=js"
export * from "./DatosSociedad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f37869a')) {
      api.createRecord('0f37869a', component.options)
    } else {
      api.reload('0f37869a', component.options)
    }
    module.hot.accept("./DatosSociedad.vue?vue&type=template&id=0f37869a", function () {
      api.rerender('0f37869a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/infoBase/DatosSociedad.vue"
export default component.exports